import { FormControl } from 'baseui/form-control'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import useMeterInput from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/MeterInput/useMeterInput'
import PdlSearchButton from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/PdlSearch/PdlSearchButton'
import getError from '@/containers/SubscriptionFormPage/getError'

const MeterInput = () => {
  const { meterIdOnBlurHandler, pdlNo, lastSentDate, isEditable, meterStatus, showPdlSearchButton, errors, t } =
    useMeterInput()

  return (
    <>
      <FormControl error={getError('meter_id_elec', errors)}>
        <>
          <SDInput
            disabled={isEditable === false || lastSentDate}
            onBlur={value => meterIdOnBlurHandler(value)}
            currentValue={pdlNo}
            label={pdlNo ? t('subscriptionForm:pdl_module.meter_id.label') : ''}
            placeholder={t('subscriptionForm:pdl_module.meter_id.placeholder')}
            status={meterStatus}
            button={<PdlSearchButton hidden={!showPdlSearchButton} />}
          />
        </>
      </FormControl>
    </>
  )
}

export default MeterInput
